import DocsAlert from './styled';

export default DocsAlert;
